import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { CustomerOverviewComponent } from './customer-overview/customer-overview.component';
import { PendingChangesGuard } from 'app/core/pending-changes.guard';
import { PrepareGuard } from 'app/core/prepare.guard';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { ProjectDialogComponent } from './project-dialog/project-dialog.component';
import { ProjectOverviewComponent } from './project-overview/project-overview.component';
import { LoadOverviewComponent } from './load-overview/load-overview.component';
import { ManualLoadDialogComponent } from './manual-load-dialog/manual-load-dialog.component';
import { CustomerMixStrengthDialogComponent } from './customer-mix-strength-dialog/customer-mix-strength-dialog.component';
import { CustomerProductPriceOverrideDialogComponent } from './customer-product-price-override-dialog/customer-product-price-override-dialog.component';
import { QuoteOverviewComponent } from './quote-overview/quote-overview.component';
import { QuoteDetailComponent } from './quote-detail/quote-detail.component';
import { QuoteLineDialogComponent } from './quote-line-dialog/quote-line-dialog.component';
import { LoadAdditiveOverviewDialogComponent } from './load-additive-overview-dialog/load-additive-overview-dialog.component';
import { LoadAdditiveDialogComponent } from './load-additive-dialog/load-additive-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'customers',
                canActivate: [PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    {
                        path: 'overview',
                        component: CustomerOverviewComponent,
                        data: { title: 'Customer Overview' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: 'loads',
                        component: LoadOverviewComponent,
                        data: { title: 'Load List' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: 'projects',
                        component: ProjectOverviewComponent,
                        data: { title: 'Project List' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: 'quotes',
                        canActivate: [PrepareGuard],
                        children: [
                            {
                                path: 'overview',
                                component: QuoteOverviewComponent,
                                data: { title: 'Quote List' },
                            },
                            {
                                path: ':id',
                                component: QuoteDetailComponent,
                                data: { title: 'Quote' },
                                canDeactivate: [PendingChangesGuard],
                            },
                        ],
                    },
                    {
                        path: ':id',
                        component: CustomerDetailComponent,
                        data: { title: 'Customer' },
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [
        CustomerOverviewComponent,
        CustomerDetailComponent,
        ProjectDialogComponent,
        ProjectOverviewComponent,
        LoadOverviewComponent,
        ManualLoadDialogComponent,
        CustomerMixStrengthDialogComponent,
        CustomerProductPriceOverrideDialogComponent,
        QuoteOverviewComponent,
        QuoteDetailComponent,
        QuoteLineDialogComponent,
        LoadAdditiveOverviewDialogComponent,
        LoadAdditiveDialogComponent
    ],
})
export class CustomersModule {}
